import { SettingItem } from '@/types/common';
import { useTranslation } from 'react-i18next';
import cls from 'classnames';
import { useAppSelector } from '@/store';
import { authSelector, interfaceLanguageSelector } from '@/store/reducers/auth';
import SVG from 'react-inlinesvg';

import rightArrow from '@/assets/svg/right-arrow.svg';
import common from '@/utils/common';

const SettingItems = ({ items, section }: { items?: SettingItem[]; section: string }) => {
  const { t } = useTranslation();
  const interfaceLanguage = useAppSelector(interfaceLanguageSelector);
  const { user } = useAppSelector(authSelector);
  const isGoogle = common.isGoogle(user);

  return (
    <div className='setting-items-wrap'>
      <h2>{t(section)}</h2>
      <div className='setting-items-tiles'>
        {items
          ?.filter(item => item.showCondition?.() || !item.showCondition)
          .map((item, index) => {
            const { trailingChild, onTap } = item;

            const hasClick = onTap && !trailingChild && !item.isToggle;
            const showArrow = item.showArrow !== false;

            const displayTrailingText =
              item.title === 'settings.grade'
                ? common.getGradeText(item.trailingText, t)
                : item.trailingText;

            if (isGoogle && item.title === 'settings.grade') return;

            return (
              <a
                key={index}
                onClick={() => {
                  if (item.onTap) {
                    item.onTap();
                  }
                }}
                className={cls('setting-item', {
                  'setting-item--clickable': Boolean(item.onTap),
                  'setting-item--disabled': !item.onTap,
                  [`setting-item-${interfaceLanguage?.direction}`]: true,
                })}
                aria-disabled={!item.onTap}
              >
                {item.icon && !item.isFlag && (
                  <span className={cls('setting-item-icon', item.icon)} />
                )}

                {item.icon && item.isFlag && (
                  <img className='setting-item-flag' src={`/langs/${item.icon}.svg`} alt='' />
                )}

                {item.leadChild && <item.leadChild />}

                <span>{t(item.title)}</span>

                {displayTrailingText && (
                  <span
                    className={cls({
                      [`setting-item-trailing-text-${interfaceLanguage?.direction}`]: true,
                    })}
                  >
                    {displayTrailingText}
                  </span>
                )}

                {item.trailingChild && (
                  <span
                    className={cls({
                      [`setting-item-trailing-text-${interfaceLanguage?.direction}`]: true,
                    })}
                    dangerouslySetInnerHTML={{ __html: item.trailingChild }}
                  ></span>
                )}

                {item.isToggle && (
                  <span
                    className={cls('setting-item-toggle', {
                      'setting-item-toggle--on': item.toggleValue,
                    })}
                    aria-checked={item.toggleValue}
                    role='switch'
                  >
                    <span className='setting-item-toggle-thumb' />
                  </span>
                )}

                {hasClick && showArrow && (
                  <img
                    className='setting-item-arrow'
                    src={item.customArrowIcon || rightArrow}
                    alt=''
                  />
                )}
              </a>
            );
          })}
      </div>
    </div>
  );
};

export default SettingItems;
